import React from "react";
import { Outlet } from "react-router-dom"; // 👈 добавили
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";

export default function MainLayout({ children }) {
  return (
    <div>
      <Header />

      <div style={{ display: "flex" }}>
        <Sidebar />

        <div
          style={{
            flex: "1 1 0%",
            minWidth: 0,
            width: 0,
            padding: "20px",
            boxSizing: "border-box",
            background: "#f2f5f9",
          }}
        >
          {children || <Outlet />} {/* 👈 ключевая строка */}
        </div>
      </div>
    </div>
  );
}
